<template>
  <div class="index-container" ref="wrap">
    <Header :nosearch="true" :title="`股圈观点`"/>
    <div class="content-wrap">
      <div class="user-info-box">
        <img :src="detail.creator.image" alt="">
        <p class="tab-title">{{detail.creator.nickName}}</p>
      </div>
      <div class="detail-wrap">
        <div class="detail-title-box">
          <p class="title">{{detail.title}}</p>
          <div>
            <span class="des" style="margin-right: 12px">{{detail.createTime | showtime}}</span>
            <span class="des">阅读量：{{detail.hitCount}}</span>
          </div>
        </div>
        <div class="detail-content">
          {{detail.newsBean.content}}
        </div>
        <div class="des-box">
          声明：用户发表的所有言论等仅代表个人观点，与本网站立场无关，不对您构成任何投资建议。
        </div>
        <div v-if="ad" style="margin-top: .12rem">
          <Ad width="3.45rem" height="0.6rem" :content="ad" />
        </div>
      </div>
      <div class="comment-warp">
        <p class="title">评论 {{totalCount}}</p>
        <div class="comment-item-box">
          <div v-for="(item, index) in list" :key="index">
            <div class="user-info-box comment">
              <img :src="item.reviewCeator.image" alt="">
              <p class="tab-title">
                {{item.reviewCeator.nickName}}
                <span v-if="item.isAuthor === 1">（作者）</span>
                <span v-if="item.parentContext">&nbsp;回复&nbsp;{{item.parentCeator.nickName}}</span>
              </p>
            </div>
            <div>
              <p class="wrap-line">{{item.reviewContext}}</p>
              <div class="parent-content wrap-line" v-if="item.parentContext">
                {{item.parentContext}}
              </div>
            </div>
            <div class="tab-label">
              <span>
                {{item.createTime | showtime}}
                <span v-if="item.status === 2" style="margin-left: 12px">评论审核中 仅本人可见</span>
              </span>
              <div class="icon-box" v-if="item.status !== 2">
                <span><i class="icon-awesome" :class="{disable: item.isSupport === 0}" @click="supportViewApi(item, index)"></i>{{item.supportCount}}</span>
                <span><i class="icon-view" @click="clickReview"></i>{{item.reviewCount}}</span>
              </div>
            </div>
            <div class="input-box" v-show="showReview && index == 0">
              <div class="bg" @click="showReview = false"></div>
              <div>
                <textarea id="inputReview" ref="input_review" type="text" class="commen-input" v-model="viewVal" :placeholder="`回复${item.reviewCeator.nickName}`"></textarea>
                <div class="flex-box">
                  <span class="des-color">{{viewVal.length}}/200</span>
                  <div class="send-btn" @click="sendApi(1, item.reviewId)" :class="{disable: viewVal.length === 0}">发送</div>
                </div>
              </div>
            </div>
          </div>
          <div class="no-data" v-if="list.length === 0">
            <img src="@/assets/no_content.png" alt="">
            <p>暂无评论</p>
            <p>赶快抢个沙发</p>
          </div>
          <infinite-loading ref="gubainf" @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
            <div slot="no-more">无更多数据</div>
            <div v-if="list.length === 0" slot="no-results" class="no-results">
            </div>
            <div v-else slot="no-results">
            </div>
            <div slot="spinner" class="tab-spinner">正在加载...</div>
          </infinite-loading>
        </div>
      </div>
      <div class="detail-footer">
        <div class="footer-content">
          <div v-show="!showAuthor" class="no-focus">
            <p @click="clickSendAuthor">回复作者...</p>
            <span><i @click="supportDetailApi" class="icon-awesome footer-icon" :class="{disable: detail.newsBean.isSupport === 0}"></i>{{detail.supportCount}}</span>
          </div>
          <div v-show="showAuthor">
            <textarea ref="author_textarea" maxlength="200" name="" id="" v-model="authorVal" placeholder="回复作者"></textarea>
            <div class="flex-box">
              <span class="des-color">{{authorVal.length}}/200</span>
              <div class="send-btn" @click="sendApi(0)" :class="{disable: authorVal.length === 0}">发送</div>
            </div>
          </div>
        </div>
        <div class="bg" @click="showAuthor = false" v-if="showAuthor"></div>
      </div>
    </div>
    <Toast v-if="showToast" :text="toastText"></Toast>
  </div>
</template>

<script type="text/ecmascript-6">
import moment from 'moment'
import { request } from '@/api/request'
import { mapState } from 'vuex'
import { publishDetail, supportReview, support, unSupportReview, unSupport } from '@/api'
import Header from '@/components/header.vue'
import Toast from '@/components/toast.vue'
import InfiniteLoading from 'vue-infinite-loading'
import Ad from '../../advertisement'

export default {
  components: { Header, Toast, InfiniteLoading, Ad },
  data () {
    return {
      showToast: false,
      newsId: this.$route.params.id,
      pageNo: 1,
      detail: {
        title: '',
        creator: {
          title: '',
          cTime: new Date(),
          image: '',
          nickName: ''
        },
        hitCount: 0, // 阅读
        reviewCount: 0, // 评论
        supportCount: 0, // 点赞
        newsBean: {
          content: '',
          isSupport: 0
        }
      },
      list: [],
      viewVal: '',
      authorVal: '',
      toastText: '',
      showReview: false,
      scrollTop: 0,
      totalCount: 0,
      showAuthor: false,
      isSend: false,
      ad: null
    }
  },
  computed: {
    ...mapState(['code', 'market', 'stockname', 'userInfo'])
  },
  filters: {
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
        return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)} ${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      }
    },
  },
  watch: {
    showReview (val, old) {
      if (val) this.viewVal = ''
    },
    showAuthor (val, old) {
      if (val) this.authorVal = ''
    }
  },
  activated() {
    this.$refs.gubainf.stateChanger.reset()
  },
  created () {
    this.getDataApi()
    this.getAd()
  },
  methods: {
    scroll() {
      this.scrollTop = this.$refs.wrap.scrollTop
    },
    async infiniteHandler($state) {
      let canload = await this.getListApi()
      if (canload) $state.loaded()
      else $state.complete()
    },
    async getDataApi () {
      const params = {
        token: this.userInfo.token,
        serverId: this.userInfo.serverId,
        appCode: '9fztgw',
        newsId: this.newsId,
        pageNo: 1,
        pageSize: 10
      }
      const res = await request.get({ url: request.apis.stockBar.detail, params })
      if (res) {
        this.detail = res
      }
    },
    async getAd() {
      let res = await request.get({
          url: request.apis.activity.activity,
          params: {
            activityStatus: 'NOW',
            hiddenStatus: 'SHOWN',
            orderBy: 'sort',
            direction: 'asc',
            position: 'flgmgmob_stockbardetail'
          }
        })
        this.ad = res.list[0]
    },
    async getListApi () {
      let params = {
        token: this.userInfo.token,
        serverId: this.userInfo.serverId,
        appCode: '9fztgw',
        newsId: this.newsId,
        pageNo: this.pageNo++,
        pageSize: 20
      }
      const res = await request.get({ url: request.apis.stockBar.reviewList, params })
      const { code, data, totalCount } = res
      if (code === 1) {
        this.list = this.list.concat(data)
        this.totalCount = totalCount
        if (data.length > 0) return true
      } else {
        return false
      }
    },
    async supportDetailApi () {
      this.isLogin()
      const params = {
        token: this.userInfo.token,
        serverId: this.userInfo.serverId,
        newsId: this.newsId
      }
      let res = this.detail.newsBean.isSupport === 0 ? await support(params) : await unSupport(params)
      if (res.code === 1) {
        this.getDataApi()
      }
    },
    async supportViewApi(item, index) {
      this.isLogin()
      const { reviewId, isSupport } = item
      const params = {
        token: this.userInfo.token,
        serverId: this.userInfo.serverId,
        newsId: this.newsId,
        reviewId
      }
      let res = isSupport === 0 ? await supportReview(params) : await unSupportReview(params)
      const url = isSupport === 0 ? request.apis.stockBar.supportReview : request.apis.stockBar.unSupportReview
      if (res.code === 1) {
        // this.getListApi()
        this.list[index].isSupport = isSupport === 0 ? 1 : 0
        this.list[index].supportCount = isSupport === 0 ? this.list[index].supportCount + 1 : this.list[index].supportCount - 1
      }
    },
    async sendApi(type = 0, reviewId = '') {
      this.isLogin()
      if (this.isSend) return
      this.isSend = true
      setTimeout(() => {
        this.isSend = false
      }, 500)
      const params = {
        token: this.userInfo.token,
        serverId: this.userInfo.serverId,
        newsId: this.newsId,
        parentId: reviewId,
        content: type === 0 ? this.authorVal : this.viewVal,
        column: 'stock.bar',
        platform: '9fztgw'
      }
      let res = await publishDetail(params)
      if (res.code === 1) {
        this._toast('评论已提交，将在审核完毕后发布')
        this.list = []
        this.pageNo = 1
        this.$refs.gubainf.stateChanger.reset()
        this.viewVal = ''
        this.authorVal = ''
        this.showReview = false
        this.showAuthor = false
      }
    },
    isLogin() {
      if (!this.userInfo.token)  {
        this._toast('请登录')
        return
      }
      // this.$router.push(`/login.html`)
    },
    clickSendAuthor() {
      this.showAuthor = true
      this.$nextTick(() => {
        console.log(this.$refs)
        this.$refs.author_textarea.focus()
      })
    },
    clickReview() {
      this.showReview = true
      this.$nextTick(() => {
        this.$refs.input_review[0].focus()
      })
    },
    reviewBlur() {
      console.log('失去焦点')
      this.showReview = false
      this.$refs.wrap.scrollTop = 0
    },
    _toast (toastText, time = 3000) {
      this.toastText = toastText
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, time)
    },
    
  }
}
</script>

<style lang="stylus" scoped>
.wrap-line
  word-wrap break-word
  word-break normal
.des-color
  color #999999
.send-btn
  width 86px
  height 32px
  line-height 32px
  text-align center
  background #F43737
  color #fff
  border-radius 2px
  &.disable
    background #BDBDBD
.flex-box
  display flex
  justify-content space-between
textarea,
input
  outline none
  border-radius 2px
.bg
  width 100%
  height 100vh
  position fixed
  left 0
  bottom 0
  background rgba(0,0,0,0.5)
.input-box *,
.content-wrap div
  box-sizing border-box
.content-wrap
  padding-top 40px
.icon-box
  display inline-flex
  justify-content space-between
  width 90px
  i
    margin-right 2px
    cursor pointer
  span
    display inline-flex
    align-items center
    line-height 20px
.index-container
  // height 100vh
  overflow-y auto
.icon-view
  display inline-block
  width 15px
  height 14px
  background-image  url('~@/assets/icon-view.png')
  background-repeat no-repeat
  background-size 100% 100%

.icon-awesome
  display inline-block
  width 15px
  height 14px
  background-image url('~@/assets/icon-awesome.png')
  background-repeat no-repeat
  background-size 100% 100%
  &.disable
    background-image url('~@/assets/icon-awesome-gray.png')
  &.footer-icon
    width 21px
    height 20px
    margin-left 16px
.user-info-box
  height 54px
  padding 12px
  background #f5f5f5
  display flex
  align-items center
  padding-bottom 12px
  margin-bottom 4px
  color #666666
  border-bottom 1px solid #F5F5F5
  &.comment
    height auto
    padding 8px 0
    background none
    border-bottom none
    p
      width 0
      flex 1
      overflow hidden
      text-overflow ellipsis
      white-space nowrap

  img
    width 30px
    height 30px
    border-radius 50%
    margin-right 8px

.detail-wrap
  padding 12px
  background #fff
  margin-bottom 12px
  .detail-title-box
    border-bottom 1px solid #F5F5F5
    padding-bottom 12px
  .detail-content
    padding 12px 0
    color #333333
    font-size 15px
    margin-bottom 12px
  .des-box
    padding 8px 12px
    font-size 12px
    color #bbb
    background #FAFAFA
  .title
    font-size 17px
    color #333
    font-weight 500
    margin-bottom 12px
  .des
    color #656B6E
    font-size 12px

.comment-warp
  font-size 15px
  background #fff
  padding 6px 8px
  padding-top 0
  padding-bottom 78px
  .title
    padding 6px 0
    font-size 15px
    color #333
    border-bottom 1px solid #EDEFF3
  .tab-label
    padding-bottom 12px
    display flex
    justify-content space-between
    font-size 12px
    color #999
    margin-top 5px
    border-bottom 1px solid #F5F5F5
  .parent-content
    padding 5px 7px
    color #666666
    background #F5F5F5
    margin 4px 0
.detail-footer
  width 100%
  position fixed
  bottom 0
  left 0
  // padding 10px 16px
  background #fff
  border 1px solid #E1E1E1
  align-content center
  *
    box-sizing border-box
  .footer-content
    background #fff
  > div
    padding 10px 16px
    box-sizing border-box
  .bg
    width 100%
    height 100vh
    z-index -1
  .no-focus
    box-sizing border-box
    display flex
    height 36px
    line-height 36px
    color #999999
    font-size 15px
    p
      flex 1
      padding 0 14px
      background #F5F5F5
      cursor pointer
  span 
    display flex
    align-items center
    color #999
    font-size 10px
  textarea
    width 100%
    height 36px
    line-height 21px
    border 1px solid #999999
    padding 0 14px
    padding-top 8px
    outline none
    margin-bottom 16px
.input-box
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  z-index 1
  .bg 
    background rgba(0,0,0,0.5)
  textarea
    width 100%
    // max-height 68px
    padding  5px 10px
    border 1px solid #999999
    margin-bottom 16px
  > div
    width 100%
    position absolute
    bottom 0
    padding 12px
    background-color #fff
.no-data
  img
    display block
    margin 20px auto
    width 200px
  p
    font-size 12px
    text-align center
    color #999999
</style>